import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import relativeTime from "dayjs/plugin/relativeTime";
import type { Task } from "fhir/r5";

import { isQuestionnaireTask } from "src-next/modules/questionnaire-builder/questionnaire-tasks";
import { isQuestionnaireAnsweredNotificationTask } from "@/utils/taskNotificationUtils";

dayjs.extend(relativeTime);
dayjs.locale("pt-br");

export function formatNotificationDateTime(dateIsoString?: string): string {
  if (!dateIsoString) return "";
  const parsed = dayjs(dateIsoString);
  if (!parsed.isValid()) return "";
  return parsed.format("DD/MM/YYYY · HH:mm");
}

export function formatNotificationRelativeTime(dateIsoString?: string): string {
  if (!dateIsoString) return "";
  const parsed = dayjs(dateIsoString);
  if (!parsed.isValid()) return "";
  return parsed.fromNow();
}

export function getNotificationDetailText(task: Task): string {
  if (typeof task.code === "object" && task.code?.text) {
    return task.code.text;
  }
  return "Sem detalhes adicionais";
}

export function getNotificationStatusLabel(
  task: Task,
  accessType?: string | null
): string {
  const isPatientView = accessType === "patient";
  const isQ = isQuestionnaireTask(task);

  if (isPatientView && isQ) {
    if (task.status === "requested") return "Pendente";
    if (task.status === "completed") return "Respondido";
    return task.status || "pendente";
  }

  if (task.status === "requested") return "Não lida";
  if (task.status === "completed") return "Lida";
  if (task.status === "in-progress") return "Em andamento";
  return task.status || "pendente";
}

export function isNotificationUnread(task: Task): boolean {
  return task.status === "requested";
}

export type NotificationVisualKind =
  | "questionnaire"
  | "questionnaireAnswered"
  | "general";

export function getNotificationVisualKind(
  task: Task,
): NotificationVisualKind {
  if (isQuestionnaireAnsweredNotificationTask(task)) {
    return "questionnaireAnswered";
  }
  if (isQuestionnaireTask(task)) {
    return "questionnaire";
  }
  return "general";
}
